import { atom } from 'jotai'

export const tradeSidePanelCollapsedAtom = atom(true)
